// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-1hLvF","flex-container":"flex-container-14E9q","flexContainer":"flex-container-14E9q"};